//  判断是pc还是移动端动态渲染节点
var browser = navigator.userAgent.toLowerCase()
let content = ''
var phone = /iphone|ipod|ipad|android|mobile|blackberry|webos|incognito|webmate|bada|nokia|lg|ucweb|skyfire|micromessenger/i

// console.log('myCustomProdSaveObj', myCustomProdSaveObj)

var myCustomProdSaveGBObj = {
    priceUnit: '¥',
    isPhone: false, // 在宽度上判断
    curVariantId: '', // 如果初始化获取url的变体，后续通过点击获取变体，如果没有url没有设置默认的变体
    curVariantAvailable: true,
    curVariantObj: {},
}

document.addEventListener('DOMContentLoaded', function () {
    setCustomProdSaveObj();
    myCustomProdSaveGBObj.isPhone = window.screen.width <= 768;
    setCustomProdSaveGBFn();
    getProductVariantPoint();
    myCustomProductAddCartClassConstructor = new myCustomProductAddCartClass('.product-template-my-AddOn-form-wrap');
    // myCustomProductAddCartClassConstructor.init();

    // 维保和保险的 初始化
    myCustomWBAndBxDomLoadInitFn();

    // 评论插件icon替换
    myCustomReviewPluginIconReplaceFn();

})
// 设置 本页全局的变量 初始化
function setCustomProdSaveGBFn() {
    myCustomProdSaveGBObj.curVariantId = getQueryVariable('variant') || myCustomProdSaveObj?.variants[0].id || '';
    if (myCustomProdSaveGBObj.curVariantId) {
        myCustomProdSaveObj.variants.forEach((item, index) => {
            if (item.id + '' === myCustomProdSaveGBObj.curVariantId + '') {
                myCustomProdSaveGBObj.curVariantAvailable = item.available;
                myCustomProdSaveGBObj.curVariantObj = { ...item };
            }
        })
    } else {
        myCustomProdSaveGBObj.curVariantAvailable = myCustomProdSaveObj.available;
        myCustomProdSaveGBObj.curVariantObj = myCustomProdSaveObj?.variants?.length ? { ...myCustomProdSaveObj.variants[0] } : {};
    }
}
// 设置 产品的数据函数
function setCustomProdSaveObj() {
    getAddOnProductVariantsNumFn()
}
// 获取 产品变体的 库存数量
function getAddOnProductVariantsNumFn() {
    let myProductAddOnSaveVariantNumIdNodeS = document.getElementsByClassName('myProductAddOnSaveVariantNumId-item')
    myProductAddOnSaveVariantNumIdNodeS = Array.from(myProductAddOnSaveVariantNumIdNodeS);
    if (myProductAddOnSaveVariantNumIdNodeS && myProductAddOnSaveVariantNumIdNodeS.length) {
        let save_variant_inventory_quantity_obj = {}
        myProductAddOnSaveVariantNumIdNodeS.forEach(nItem => {
            let text = nItem.textContent.trim();
            let textArr = text && text.split(':');
            let keyId = textArr && textArr.length && textArr[0];
            let valueId = textArr && textArr.length && textArr.length > 1 && textArr[1];
            save_variant_inventory_quantity_obj[keyId] = valueId;
        })
        myCustomProdSaveObj.save_variant_inventory_quantity_obj = save_variant_inventory_quantity_obj;
        myCustomProdSaveObj.variants.forEach((item, index) => {
            item.inventory_quantity = save_variant_inventory_quantity_obj[item.id] || 0;
        })
    }
};

function getQueryVariable(variable) {
    // 从?开始获取后面的所有数据
    var query = window.location.search.substring(1);
    // 从字符串&开始分隔成数组split
    var vars = query.split("&");
    // 遍历该数组
    for (var i = 0; i < vars.length; i++) {
        // 从等号部分分割成字符
        var pair = vars[i].split("=");
        // 如果第一个元素等于 传进来的参的话 就输出第二个元素
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}
function changeTitle() {
    setTimeout(() => {
        var variantId = getQueryVariable('variant')
        myCustomProdSaveGBObj.curVariantId = variantId;
        setCustomProdSaveGBFn();
        getProductVariantPoint(variantId);
        // 当前产品变体变化 需要修改数据
        // myCustomAddOnCurrentVariantChangeFn(variantId);
        // myCustomSetAvaliableBtnStrFn();
        // 当前产品变体变化 需要修改打折相关的函数变化
        myCustomProdDCConfigObj.dCConfigVariantChangeFn(variantId)

        // 当前产品的变体变化，悬浮购物车的相关函数变化
        myCustomProductAddCartClassConstructor.addVariantEventListenerFn();

        $('.get-variant-id').each(function () {
            if ($(this).attr('value') == variantId) {
                if ($(this).attr('nowName')) {
                    $('.product-name').html($(this).attr('nowName'))
                }
                if ($(this).attr('nowdesc')) {
                    $('.productDesc').html($(this).attr('nowdesc'))
                }
            }
        })
        // 这里是执行 根据变体id 产品图片展示不同的
        MyCustomProductSliderConstructor.myProdSliderVariantForImg(variantId)

        // 这里是执行，根据变体的id,执行维保&保险
        myCustomWBVariantIdChangeFn(variantId);

        // 这里是执行，根据变体的id,执行 送礼物的展示和隐藏
        myCustomGiftVariantChangeFn(variantId);

        // 这里是执行，根据变体的id,执行MSRP
        myCustomMsrpVariantChangeFn(variantId);
    })
}

// 监听根据变体id 更换 变体的积分
function getProductVariantPoint(variantId) {
    let noSHowProductToPointArr = [''];
    let myProductId = myCustomProdSaveObj.id;
    console.log(noSHowProductToPointArr, 'noSHowProductToPointArr', myProductId, 'myProductId');
    if (noSHowProductToPointArr.includes(myProductId)) {
        $('.my-product-price-point-wrap').css('display', 'none');
        return;
    }
    const pointPerUnit = 4
    let myProductVariantPointId = document.getElementById('myProductVariantPointId')
    // console.log(myProductVariantPointId, 'myProductSaveVariantPointId')

    let myProductVariantPointMoneyNode = document.getElementById('myProductVariantPointMoney')

    let myvariantId = ''
    if (variantId) {
        myvariantId = variantId
    } else {
        myvariantId = getQueryVariable('variant')
    }
    // console.log(myvariantId, 'myvariantId')

    if (myvariantId) {
        let myProductSaveVariantPointIdNode = document.getElementById('myProductSaveVariantPointId')
        let myProductSaveVariantNodes = myProductSaveVariantPointIdNode.getElementsByTagName("div")
        console.log(myProductSaveVariantPointIdNode, myProductSaveVariantNodes, 'myProductVariantPointIdNode.chidrenNode')
        myProductSaveVariantNodes = Array.from(myProductSaveVariantNodes);
        if (myProductSaveVariantNodes.length && myProductVariantPointId && myProductVariantPointMoneyNode) {
            myProductSaveVariantNodes.forEach(item => {
                console.log(item)
                let str = item.innerHTML
                let strArr = str.split(':')
                if (strArr[0] === myvariantId) {
                    myProductVariantPointId.innerHTML = strArr[1]
                    let pointMoney = (strArr[1] * pointPerUnit).toLocaleString()
                    myProductVariantPointMoneyNode.innerHTML = pointMoney
                }
            })
        }
    } else {
        let moneyNum = myProductVariantPointId.innerHTML
        let pointMoney = (moneyNum * pointPerUnit).toLocaleString()
        myProductVariantPointMoneyNode.innerHTML = pointMoney
    }
}

// 获取预计送达的时间
function getMyProductEstimatedStrFn() {
    let dateStr = ''
    let myDate = new Date()
    let myYMD = myDate.toLocaleDateString() // '2023/10/11'
    let myZJ = myDate.getDay() > 0 ? myDate.getDay() : '7'
    let myHour = myDate.getHours()
    let addDayFn = function (day) {
        // console.log(day, '算 几天后')

        let ndd = new Date()
        ndd.setDate(ndd.getDate() + day)
        // console.log(ndd, 'ndd 复制几天后')
        let yy = ndd.getFullYear()
        let mm = ndd.getMonth() < 9 ? '0' + (ndd.getMonth() + 1) : (ndd.getMonth() + 1)
        let d = ndd.getDate() < 10 ? '0' + ndd.getDate() : ndd.getDate()
        // console.log(yy, mm, d, 'yy, mm, d')

        return yy + '/' + mm + '/' + d
    }
    // 如果是周五-周日
    if (myZJ - 5 >= 0) {
        let num = 7 - myZJ + 1
        dateStr = addDayFn(num)
    } else {
        // 周一到周四
        dateStr = addDayFn(1)
    }
    return dateStr
}

// 以下是 四个 官网提示的函数  这里可以封装为一个 class
$('#myProductPcFourInfoHelpId').click(function (e) {
    $('#myProductPcFourInfoDialogId').css('display', 'block')
})
$('#myProductPcFourInfoDialogCloseId').click(function (e) {
    $('#myProductPcFourInfoDialogId').css('display', 'none')
})

$(document).ready(function () {
    let currentIndex = 0;
    let slides = $('.my-product-pc-fourInfo-dialog-item');

    function showSlide(index) {
        slides.hide().eq(index).fadeIn();
    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    }

    function prevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        showSlide(currentIndex);
    }

    // 初始化显示第一张轮播图
    showSlide(currentIndex);

    // 下一张按钮点击事件
    $('#myProductPcFourInfoDialogRight').click(function () {
        nextSlide();
    });

    // 上一张按钮点击事件
    $('#myProductPcFourInfoDialogLeft').click(function () {
        prevSlide();
    });

    // 更改下边点对应的active
    function changeMyProductPromotionNewPointActiveFn(index) {
        let myElementPoints = $('.my-product-mb-fourInfo-dialog-point');
        myElementPoints.each(function (eIndex) {
            if (eIndex === index) {
                // myElementPoints.eq(index).css('background','#9CA1A4')
                $(this).css({
                    'background': '#9CA1A4'
                });
            } else {
                $(this).css({
                    'background': '#DADDDF'
                });
            }
        });
    }

    let myMbTouchStartX, myMbTouchMoveX, myMbTouchEndX, myMbTouchNX
    // 监听对应的区域，判断手机触摸后的情况
    $('.my-product-pc-fourInfo-dialog-itemwrap').on('touchstart', function (event) {
        let touch = event.touches[0]
        myMbTouchStartX = Math.floor(touch.pageX);
    });

    $('.my-product-pc-fourInfo-dialog-itemwrap').on('touchend', function (event) {
        let touch = event.changedTouches[0];
        myMbTouchEndX = Math.floor(touch.pageX);
        myMbTouchNX = myMbTouchEndX - myMbTouchStartX;
        if (myMbTouchNX <= -30) {
            // 左滑
            nextSlide();
            changeMyProductPromotionNewPointActiveFn(currentIndex);
            return false
        } else if (myMbTouchNX >= 30) {
            // 右滑
            prevSlide();
            changeMyProductPromotionNewPointActiveFn(currentIndex);
            return false
        } else if (-30 < myMbTouchNX < 30) {
            console.log('点击')
            // return false
        }
    });
});
// 以下是 四个 官网提示的函数 -----end 

// 可以封装为一个 class
/** -------- start 以下是 产品的打折的相关函数 */
//   刚进入页面需要获取判断有没有 变体id
//   1. 根据变体 变化 获取对应的值
//   2. 根据 type 类型，进行 隐藏显示的函数
//   3. 
let myCustomProdDCConfigObj = {
    allConfigObj: {},
    variantConfigObj: {},
    variantSavedId: '',
    dCConfigVariantChangeFn: (variantId) => {
        myCustomProdDCConfigObj.variantSavedId = variantId;
        myCustomProdDCConfigObj.startSetDataFn();
    },
    startMountInitFn: () => {
        $(document).ready(function () {
            // 获取初始化的数据
            myCustomProdDCConfigObj.initGetDataFn();
            // 如果刚进入页面url中有没有 变体id 需要设置数据
            let urlVariantId = getQueryVariable('variant');
            if (urlVariantId) {
                myCustomProdDCConfigObj.variantSavedId = urlVariantId;
            }
            myCustomProdDCConfigObj.startSetDataFn();
        })
    },
    startSetDataFn: () => {
        myCustomProdDCConfigObj.variantConfigObj = myCustomProdDCConfigObj.variantSavedId && myCustomProdDCConfigObj.allConfigObj && myCustomProdDCConfigObj.allConfigObj[myCustomProdDCConfigObj.variantSavedId]
        //console.log(myCustomProdDCConfigObj.variantConfigObj,'myCustomProdDCConfigObj.variantConfigObj')
        myCustomProdDCConfigObj.hideDataFn();
        myCustomProdDCConfigObj.setDataFn();
    },
    initGetDataFn: () => {
        //myCustomProdDCConfigObj.variantSavedId = $('#myProdDCConfigVariantSavedId').html();
        myCustomProdDCConfigObj.variantSavedId = $('#myProdDCConfigVariantSavedId').text().trim();
        console.log(myCustomProdDCConfigObj.variantSavedId, '获取出默认的选择的变体 id');
        //let myProdDCConfigVariantObj = $('#myProdDCConfigVariantObjSavedId').html();
        let myProdDCConfigVariantObj = $('#myProdDCConfigVariantObjSavedId').text();
        myCustomProdDCConfigObj.allConfigObj = myProdDCConfigVariantObj && JSON.parse(myProdDCConfigVariantObj);
        console.log(myCustomProdDCConfigObj.allConfigObj, 'myCustomProdDCConfigObj.configObj');
    },
    setDataFn: () => {
        let variantConfigObj = myCustomProdDCConfigObj.variantConfigObj;
        if (variantConfigObj && variantConfigObj['direct'] && variantConfigObj['direct'].counponkey) {
            $('#myProdDCConfigDirectNumberId').text(variantConfigObj['direct'].number);
            $('#myProdDCConfigDirectDescId').text(variantConfigObj['direct'].desc);

            $('#myProdDCConfigDirectNumberId').removeClass('myCustomProdDCNoShow');
            $('#myProdDCConfigDirectDescId').removeClass('myCustomProdDCNoShow');
        }

        if (variantConfigObj && variantConfigObj['point'] && variantConfigObj['point'].counponkey) {
            $('#myProdDCConfigPointNumberId').text(variantConfigObj['point'].number);
            $('#myProdDCConfigPointDescId').text(variantConfigObj['point'].desc);
            $('#myProdDCConfigPointDescId').attr('data-counponkey', variantConfigObj['point'].counponkey);

            $('#myProdDCConfigPointNumberId').removeClass('myCustomProdDCNoShow');
            $('#myProdDCConfigPointDescShowId').removeClass('myCustomProdDCNoShow');
        }

    },
    hideDataFn: () => {
        // 先清空 所有的数据
        $('#myProdDCConfigPointDescId').attr('data-counponkey', '');
        $('#myProdDCConfigPointNumberId').text('');
        $('#myProdDCConfigPointDescId').text('');
        $('#myProdDCConfigPointNumberId').addClass('myCustomProdDCNoShow');
        $('#myProdDCConfigPointDescShowId').addClass('myCustomProdDCNoShow');


        $('#myProdDCConfigDirectNumberId').text('');
        $('#myProdDCConfigDirectDescId').text('');
        $('#myProdDCConfigDirectNumberId').addClass('myCustomProdDCNoShow');
        $('#myProdDCConfigDirectDescId').addClass('myCustomProdDCNoShow');

    },
}
myCustomProdDCConfigObj.startMountInitFn();
/** --------end 以下是 产品的打折的相关函数 */

/** -------- start 以下是 产品的公共配置的相关函数 */
myCustomProdCommonConfigObj = {
    currentProdObj: {},
    initGetData: () => {
        $(document).ready(function () {
            myCustomProdCommonConfigObj.hideStyleFn();
            let currentProdObj = $('#myProdCommonConfigVariantObjSavedId').text();
            myCustomProdCommonConfigObj.currentProdObj = JSON.parse(currentProdObj);
            if (myCustomProdCommonConfigObj.currentProdObj) {
                myCustomProdCommonConfigObj.setDataAndStyleFn();
            }
        })
    },
    hideStyleFn: () => {
        $('#myProdDCConfigDirectLabelId').addClass('myCustomProdDCNoShow');
    },
    setDataAndStyleFn: () => {
        if (!myCustomProdCommonConfigObj.currentProdObj.configLabels) return;
        let configLabelsArr = myCustomProdCommonConfigObj.currentProdObj.configLabels.split(',');
        let resHtml = ''
        if (configLabelsArr && configLabelsArr.length) {
            configLabelsArr.forEach((item, index) => {
                resHtml += `<div style="margin-right:4px;padding: 4px 10px;border: 1px solid #e0393a; border-radius: 4px;">${item}</div>`
            });
            $('#myProdDCConfigDirectLabelId').html(resHtml);
            $('#myProdDCConfigDirectLabelId').removeClass('myCustomProdDCNoShow');
        }
    },
}
myCustomProdCommonConfigObj.initGetData();
/** --------end 以下是 产品的公共配置的相关函数 */

// 可以封装为一个 class
/**
   以下是 addOn 相关的函数
 */
// ートに追加    まとめてカートに追加     在庫切れ
// 存储 全部的 available: true 的 add on的所有产品信息
window.myProductAddOnOriginObj = {}
// 存储当前的产品的变体
// window.myCurrentProductVariantsObjArr = []
// 存储当前的产品的 变体的数量，因为要判断 产品销售状态
// window.myProductAddOnVariantNumObj = {}

// 存储 当前产品的  的加购信息
window.myCurrentProductAddOnObj = {}
// 存储 外部的 所有 add on 的 加购信息
window.myProductVariantAddOnObj = {}
// 存储 弹窗的 所有  add on 的加购信息
window.myProductVariantAddOnDialogObj = {}

// 获取 myCustomAddOnProductSaveProdItemObj 下存的所有的add on 的信息
function myCustomProductGetAllAddOnObjFn() {
    let myCustomAddOnProductSaveProdItemObjArr = $('.myCustomAddOnProductSaveProdItemObj')
    if (myCustomAddOnProductSaveProdItemObjArr && myCustomAddOnProductSaveProdItemObjArr.length) {
        myCustomAddOnProductSaveProdItemObjArr.each(function () {
            // console.log($(this), $(this).html(), $(this).attr('data-id'),'data-id-id-id');
            let ProdItemObjStr = $(this).text();
            let ProdItemObjId = $(this).attr('data-id');
            if (ProdItemObjId) {
                window.myProductAddOnOriginObj[ProdItemObjId] = JSON.parse(ProdItemObjStr) || {};
                window.myProductVariantAddOnObj[ProdItemObjId] = {
                    checkStatus: false,
                    variantId: '',
                    quantity: 1,
                    available: false,
                };
                window.myProductVariantAddOnDialogObj[ProdItemObjId] = {
                    variantId: '',
                    quantity: 1,
                    openStatus: false,
                };
            }
        })
    }
    // console.log(window.myProductAddOnOriginObj);
}

// 设置一下 初始化的 add on 的产品的 数据信息
function myCustomAddOnProdItemSelectInitDataFn() {
    $('.product-template-my-AddOn-prodlist-item-selct-select').each(function () {
        let ProdItemObjProdId = $(this).attr('data-prod-id');
        let ProdItemObjVariantId = $(this).attr('data-varinat-id');
        let ProdItemObjVariantPrice = $(this).attr('data-variant-single-mp');

        window.myProductVariantAddOnObj[ProdItemObjProdId] = {
            checkStatus: false,
            variantId: ProdItemObjVariantId || '',
            quantity: 1,
            available: false,
            price: ProdItemObjVariantPrice || 0,
            // 初始化设置下 折扣
            directDC: myCustomAddOnGetDCFn(ProdItemObjProdId,ProdItemObjVariantId)
        };

        window.myProductVariantAddOnDialogObj[ProdItemObjProdId] = {
            variantId: ProdItemObjVariantId || '',
            quantity: 1,
            openStatus: false,
            // 初始化设下折扣
            directDC: myCustomAddOnGetDCFn(ProdItemObjProdId,ProdItemObjVariantId)
        };
    })
    myCustomAddOnDiscountSetFn(true,'dialog');
    myCustomAddOnDiscountSetFn(true,'noDialog');
    myCustomAddOnDialogAddBtnStrFn(true);
};

// 监听 某个 add on click 是否选中 希望加个防抖
function myCustomProdAddOnItemClickFn(dom, event) {
    let ProdItemObjProdId = $(dom).attr('data-id');
    if (window.myProductVariantAddOnObj[ProdItemObjProdId] && window.myProductVariantAddOnObj[ProdItemObjProdId].checkStatus) {
        // 需要 取消 样式 边框和选中状态
        $(dom).removeClass('my-AddOn-prodlist-item-active');
        window.myProductVariantAddOnObj[ProdItemObjProdId].checkStatus = false;
    } else {
        // 需要设置样式 边框和选中状态
        $(dom).addClass('my-AddOn-prodlist-item-active');
        window.myProductVariantAddOnObj[ProdItemObjProdId].checkStatus = true;
    }
    console.log('外部选中的', window.myProductVariantAddOnObj);
    // 计算 悬浮 money
    myCustomProductAddCartClassConstructor.addAddOnEventListenerFn()
};

// 监听 add on 变体 选择，展开变体列表
function myCustomAddOnProdItemSelectVariantFn(selectVariantDom, event) {
    event.stopPropagation();
};
// 监听 add on 变体 选择，来进行数据复制和金额计算
function myAddOnCustomOnChangeVariant(variantId, dom, event) {
    // console.log(variantId,dom,event,'variantId,dom,eventvariantId,dom,event');
    let selectedVarinatItemOption = $(dom).find(':selected');
    // console.log(selectedVarinatItemOption,'selectedOptionselectedOption');

    let ProdItemObjVariantId = variantId;
    let ProdItemObjProdId = selectedVarinatItemOption.attr('data-prod-id');

    let varinatItemObjTitle = selectedVarinatItemOption.attr('data-title');
    let varinatItemObjImgsrc = selectedVarinatItemOption.attr('data-imgsrc');
    let varinatItemObjPrice = selectedVarinatItemOption.attr('data-variant-single-mp');
    let varinatItemObjComparePrice = selectedVarinatItemOption.attr('data-variant-single-comparemp');

    $(dom).closest('.product-template-my-AddOn-prodlist-item').find('.product-template-my-AddOn-prodlist-itemimg img').attr('src', '/cdn/shop/' + varinatItemObjImgsrc);
    $(dom).closest('.product-template-my-AddOn-prodlist-item').find('.product-template-my-AddOn-prodlist-item-price-red').text(varinatItemObjPrice);
    // $(dom).closest('.product-template-my-AddOn-prodlist-item').find('.product-template-my-AddOn-prodlist-item-price-line').text(varinatItemObjComparePrice);

    if (window.myProductVariantAddOnObj[ProdItemObjProdId] && window.myProductAddOnOriginObj[ProdItemObjProdId]) {
        let variantArr = (window.myProductAddOnOriginObj[ProdItemObjProdId] && window.myProductAddOnOriginObj[ProdItemObjProdId].variants) || []
        if (variantArr && variantArr.length) {
            variantArr.map(j => {
                if ((j.id + '') === (ProdItemObjVariantId + '')) {
                    console.log('hhhhhhhh222', j);
                    window.myProductVariantAddOnObj[ProdItemObjProdId].variantId = ProdItemObjVariantId;
                    window.myProductVariantAddOnObj[ProdItemObjProdId].price = j.price;
                    if (window.myProductVariantAddOnObj[ProdItemObjProdId].checkStatus) {
                        myCustomProductAddCartClassConstructor.addAddOnEventListenerFn();
                    }
                    // 切换变体重新获取折扣，并且将新的折扣重新渲染
                    window.myProductVariantAddOnObj[ProdItemObjProdId].directDC = myCustomAddOnGetDCFn(ProdItemObjProdId,ProdItemObjVariantId);
                    myCustomAddOnDiscountSetFn(false,'noDialog',ProdItemObjProdId);
                }
            })
        }
    }

};
// 点击 外部 addOn 加购按钮的 函数处理
function myCustomAddOnCartBtnClickFn() {
    let items = []
    if (window.myCurrentProductAddOnObj && window.myCurrentProductAddOnObj.available && window.myCurrentProductAddOnObj.variantId) {
        items.push({
            'id': window.myCurrentProductAddOnObj.variantId,
            'quantity': window.myCurrentProductAddOnObj.quantity || 1
        })
        for (addonItem in window.myProductVariantAddOnObj) {
            let itemAddonProdCheckStatus = !!myProductVariantAddOnObj[addonItem].checkStatus;
            if (itemAddonProdCheckStatus) {
                items.push({
                    'id': myProductVariantAddOnObj[addonItem].variantId,
                    'quantity': myProductVariantAddOnObj[addonItem].quantity || 1
                })
            }
        }
        if (items && items.length) {
            let formData = { items: items };
            console.log(formData, 'formDataformDataformData');
            myCustomAddOnProdAddToCartFn(formData);
            // 外边 addon 加购成功后，需要把 选中的 清空掉 清空数据 和样式，还需要把悬浮的金额重置
            for (addOnItem in window.myProductVariantAddOnObj) {
                window.myProductVariantAddOnObj[addOnItem].checkStatus = false;
            }
            $('.product-template-my-AddOn-prodlist-item').each(function () {
                $(this).removeClass('my-AddOn-prodlist-item-active')
            })
        }
    }
};
// 只是加入购物车的 接口 公共函数
function myCustomAddOnProdAddToCartFn(formData) {
    console.log('ssssssssXMLHttpRequest')
    //   let formData = {
    //       'items': [{
    //           'id': 42912208617647,
    //           'quantity': 2
    //       },{
    //           'id': 41793064108207,
    //           'quantity': 1
    //       }]
    //   };

    let xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                console.log('Product added to cart successfully:', xhr.responseText);
            } else {
                console.error('Failed to add product to cart:', xhr.statusText);
            }
        }
    };

    xhr.send(JSON.stringify(formData));
};

function myCustomAddOnGetDCFn(prodId,variantId){
    // 返回折扣或者 ''
    let directDC = '';
    // 从折扣的对象中匹配下
    if(window.myProdDCConfigCustomObj&&window.myProdDCConfigCustomObj[prodId]&&window.myProdDCConfigCustomObj[prodId][variantId]) {
        directDC = window.myProdDCConfigCustomObj[prodId][variantId]?.direct?.number;
    }
    return directDC;
}
// addon 折扣的函数的设置
function myCustomAddOnDiscountSetFn(isAll,type,prodId){
    if(type === 'dialog'){
        $('.product-template-my-AddOn-dialog-dc-wrap').each(function () {
            let ProdItemObjProdId = $(this).attr('data-id');
            if (isAll){
                if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC) {
                    $(this).text(window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC + 'クーポンあり' );
                    $(this).addClass('show');
                    $(this).parent().find('.myAddOnDialogProdDCConfigDirectDescId').css('display','inline-block');
                } else {
                    $(this).text('');
                    $(this).removeClass('show');
                    $(this).parent().find('.myAddOnDialogProdDCConfigDirectDescId').css('display','none');
                }
            } else {
                if (ProdItemObjProdId === prodId) {
                    if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC) {
                        $(this).text(window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC + 'クーポンあり' );
                        $(this).addClass('show');
                        $(this).parent().find('.myAddOnDialogProdDCConfigDirectDescId').css('display','inline-block');
                    } else {
                        $(this).text('');
                        $(this).removeClass('show');
                        $(this).parent().find('.myAddOnDialogProdDCConfigDirectDescId').css('display','none');
                    }
                }
            }
        })
    } else {
        $('.product-template-my-AddOn-dc-wrap').each(function () {
            let ProdItemObjProdId = $(this).attr('data-id');
            if (isAll){
                if (window.myProductVariantAddOnObj[ProdItemObjProdId].directDC) {
                    $(this).text(window.myProductVariantAddOnObj[ProdItemObjProdId].directDC + 'クーポンあり' );
                    $(this).addClass('show');
                } else {
                    $(this).text('');
                    $(this).removeClass('show');
                }
            } else {
                if (ProdItemObjProdId === prodId) {
                    if (window.myProductVariantAddOnObj[ProdItemObjProdId].directDC) {
                        $(this).text(window.myProductVariantAddOnObj[ProdItemObjProdId].directDC + 'クーポンあり' );
                        $(this).addClass('show');
                    } else {
                        $(this).text('');
                        $(this).removeClass('show');
                    }
                }
            }
        })
    }
}
// addon 弹窗的 按钮的 内容
function myCustomAddOnDialogAddBtnStrFn(isAll,prodId){
    if(isAll){
        $('.product-template-my-AddOn-prodlist-dialog-add').each(function () {
            let ProdItemObjProdId = $(this).attr('data-id');
            if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC) {
                $(this).find('.product-template-my-AddOn-prodlist-dialog-add-dc').text(window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC+'');
                $(this).find('.product-template-my-AddOn-prodlist-dialog-add-text').text('を適用してカートに追加' );
            } else {
                $(this).find('.product-template-my-AddOn-prodlist-dialog-add-dc').text('');
                $(this).find('.product-template-my-AddOn-prodlist-dialog-add-text').text('カートに追加' );
            }
        })
    } else {
        $('.product-template-my-AddOn-prodlist-dialog-add').each(function () {
            let ProdItemObjProdId = $(this).attr('data-id');
            if (ProdItemObjProdId+'' === prodId+''){
                if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC) {
                    console.log(window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC,'window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC')
                    $(this).find('.product-template-my-AddOn-prodlist-dialog-add-dc').text(window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC+'');
                    $(this).find('.product-template-my-AddOn-prodlist-dialog-add-text').text('を適用してカートに追加' );
                } else {
                    $(this).find('.product-template-my-AddOn-prodlist-dialog-add-dc').text('');
                    $(this).find('.product-template-my-AddOn-prodlist-dialog-add-text').text('カートに追加' );
                }
            }
        })
    }
}

/**
*  以下是 addon 弹窗相关的 函数
*/
// 要监听  add on 弹窗的 mask 的点击，关闭弹窗
function myCustomProdAddOnProductDetailMaskClickFn(dom, event) {
    event.stopPropagation();
    let ProdItemObjProdId = $(dom).attr('data-id');
    // console.log(ProdItemObjProdId, 'myCustomProdAddOnProductDetailMaskClickFnProdItemObjProdId')
    $(dom).closest('.product-template-my-AddOn-prodlist-item-wrap').find('.product-template-my-AddOn-prodlist-dialogitem').css('display', 'none');
    if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId] && window.myProductVariantAddOnDialogObj[ProdItemObjProdId].variantId) {
        window.myProductVariantAddOnDialogObj[ProdItemObjProdId].openStatus = false;
    }
    myCustomAddOnDilaogShowListenFn(true);
};
// 监听 add on 弹窗的 详情打开按钮
function myCustomProdAddOnProductDetailClickFn(dom, event, flag) {
    event.stopPropagation();
    let ProdItemObjProdId = $(dom).attr('data-id');
    if (flag === 1) {
        $(dom).closest('.product-template-my-AddOn-prodlist-item-wrap').find('.product-template-my-AddOn-prodlist-dialogitem').css('display', 'block');
    } else {
        $(dom).closest('.product-template-my-AddOn-prodlist-item-wrap').find('.product-template-my-AddOn-prodlist-dialogitem').css('display', 'none');
    }
    // console.log(window.myProductVariantAddOnDialogObj[ProdItemObjProdId],'window.myProductVariantAddOnDialogObj[ProdItemObjProdId]');
    if (window.myProductVariantAddOnDialogObj[ProdItemObjProdId] && window.myProductVariantAddOnDialogObj[ProdItemObjProdId].variantId) {
        window.myProductVariantAddOnDialogObj[ProdItemObjProdId].openStatus = !!flag;
    }
    myCustomAddOnDilaogShowListenFn(!flag);
};
// 监听 add on 弹窗 打开或关闭 在手机端情况下把 悬浮购物车 隐藏或显示
function myCustomAddOnDilaogShowListenFn(flag) {
    if (myCustomUtilsIsMbWidth()) {
        $('.product-template-my-AddOn-form-wrap').css('visibility', flag ? 'visible' : 'hidden');
    }
};

// 监听 add on 弹窗的 变体选择，展开变体选择列表
function myCustomAddOnDialogProdItemSelectVariantFn(selectVariantDom, event) {
    event.stopPropagation();
};
// 监听 add on 弹窗的 变体的 option 点击事件
function myAddOnDialogCustomOnChangeVariant(variantId, dom, event) {
    // console.log(variantId,dom,event,'variantId,dom,eventvariantId,dom,event');
    let selectedVarinatItemOption = $(dom).find(':selected');
    // console.log(selectedVarinatItemOption,'selectedOptionselectedOption');

    let ProdItemObjVariantId = variantId;
    let ProdItemObjProdId = selectedVarinatItemOption.attr('data-prod-id');

    let varinatItemObjTitle = selectedVarinatItemOption.attr('data-title');
    let varinatItemObjImgsrc = selectedVarinatItemOption.attr('data-imgsrc');
    let varinatItemObjPrice = selectedVarinatItemOption.attr('data-variant-single-mp');
    let varinatItemObjComparePrice = selectedVarinatItemOption.attr('data-variant-single-comparemp');

    $(dom).closest('.product-template-my-AddOn-prodlist-dialogitem').find('.product-template-my-AddOn-prodlist-dialog-imgwrap img').attr('src', '/cdn/shop/' + varinatItemObjImgsrc);
    $(dom).closest('.product-template-my-AddOn-prodlist-dialogitem').find('.product-template-my-AddOn-prodlist-dialog-price-red').text(varinatItemObjPrice);
    $(dom).closest('.product-template-my-AddOn-prodlist-dialogitem').find('.product-template-my-AddOn-prodlist-dialog-price-line').text(varinatItemObjComparePrice);

    if (window.myProductVariantAddOnDialogObj && window.myProductVariantAddOnDialogObj[ProdItemObjProdId]) {
        let variantArr = (window.myProductAddOnOriginObj[ProdItemObjProdId] && window.myProductAddOnOriginObj[ProdItemObjProdId].variants) || []
        if (variantArr && variantArr.length) {
            variantArr.map(j => {
                if ((j.id + '') === (ProdItemObjVariantId + '')) {
                    window.myProductVariantAddOnDialogObj[ProdItemObjProdId].variantId = ProdItemObjVariantId;
                    window.myProductVariantAddOnDialogObj[ProdItemObjProdId].directDC = myCustomAddOnGetDCFn(ProdItemObjProdId, ProdItemObjVariantId);
                    myCustomAddOnDiscountSetFn(false,'dialog',ProdItemObjProdId);
                    myCustomAddOnDialogAddBtnStrFn(false,ProdItemObjProdId);
                }
            })
        }
    }
};
// 监听 add on 弹窗的 数量增减的 点击事件 这里应做 防抖处理
function myCustomProdAddOnDialogQuantityClickFn(dialogQuantityDom, event, flag) {
    event.stopPropagation();
    let dialogQuantityDomProdId = $(dialogQuantityDom).parent().attr('data-prod-id');
    console.log(dialogQuantityDomProdId, 'add on 弹窗的 数量增减的', flag, typeof flag, !flag, !!flag)
    if (window.myProductVariantAddOnDialogObj[dialogQuantityDomProdId] && window.myProductVariantAddOnDialogObj[dialogQuantityDomProdId].variantId) {
        let currentQuantity = window.myProductVariantAddOnDialogObj[dialogQuantityDomProdId].quantity || 1
        // 获取点击的子元素
        let clickedElement = $(event.target);
        // 判断点击的是哪个子元素
        if (!flag) {
            console.log('点击了减少按钮');
            if (currentQuantity > 1) {
                currentQuantity--;
            } else {
                currentQuantity = 1;
            }
        } else if (!!flag) {
            console.log('点击了增加按钮');
            if (currentQuantity < 100) {
                currentQuantity++;
            } else {
                currentQuantity = 100;
            }
        } else {
            // console.log('点击了父级 div');
        }
        window.myProductVariantAddOnDialogObj[dialogQuantityDomProdId].quantity = currentQuantity;
        // 更新 弹窗 对应的数字 dom
        setTimeout(() => {
            let quantity = window.myProductVariantAddOnDialogObj[dialogQuantityDomProdId].quantity;
            $(dialogQuantityDom).parent().find('.product-template-my-AddOn-prodlist-dialog-num-value').text(quantity)
        })
    }
};
// 点击 弹窗单个 addOn 加购按钮的 函数处理
function myCustomSingleAddOnProdAddCartClickFn() {
    let items = []
    for (addonItem in window.myProductVariantAddOnDialogObj) {
        if (myProductVariantAddOnDialogObj[addonItem].openStatus) {
            items.push({
                'id': myProductVariantAddOnDialogObj[addonItem].variantId,
                'quantity': myProductVariantAddOnDialogObj[addonItem].quantity || 1,
                'properties': {
                    '_customAddon': myProductVariantAddOnObj[addonItem].variantId
                }
            })
        }
    }
    // console.log(items, 'itemsitemsitems',myProductVariantAddOnDialogObj)
    if (items && items.length) {
        let formData = { items: items };
        // console.log(formData,'formDataformDataformData');
        myCustomAddOnProdAddToCartFn(formData);
    }
};

/**
* 这个是 监听 shopify 原生的 加购按钮的 myProductAddCartButtonId
*/
function myCustomAddOnOriginAddCartBtnOnClickFn() {
    $('#myCustomPordTemplateAddonClickBtn').on('click', function () {
        myCustomProductAddCartClassConstructor.myCustomAddOnCartBtnClickFn();
    });
};
/**
*  以下是工具函数
*/
function myCustomAddOnformatNumberWithCommas(num) {
    num = num + '';
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
function myCustomUtilsIsMbWidth() {
    return window.screen.width < 767
}

$(document).ready(function () {
    // getAddOnProductVariantsNumFn();
    // getCurrentProductVariantsArrFn();
    // 新增判断是否显示title
    myCustomProductGetAllAddOnObjFn();
    // myObserveOriginProductQUantityChangeFn();
    myCustomAddOnProdItemSelectInitDataFn();
    // myCustomAddOnBtnInitDataFn();
    myCustomAddOnOriginAddCartBtnOnClickFn();

    // 2024年8月15日11:25:12 新增
    // myObserveOriginProdQuantityInputChangeFn()
    // myCustomProductAddOnFnObj.checkCurProdHasOnlyVariantFn();
    // myCustomProductAddOnFnObj.checkCurProdCurVariantIsNoBuyFn();

    // 2025年7月10日20:01:18 新增为了 产品的 功能配置
    myCustomFuncConfigStartFn()

    // 页面初始化时，根据默认变体判断是否展示送礼物模块
    myCustomGiftVariantChangeFn();

    // 页面初始化，根据默认变体展示MSRP
    myCustomMsrpVariantChangeFn();
})

// 2024年8月19日18:51:18 为了description
function myCustomProdDescItemClick(dom, event) {
    // console.log('sssssssssssssss')
    if ($(dom).parent().find(".my-custom-prod-desc-item-cont").hasClass("custom-prod-desc-item-cont-show")) {
        $(dom).removeClass("custom-prod-desc-item-title-active");
        $(dom).parent().find(".my-custom-prod-desc-item-cont").removeClass("custom-prod-desc-item-cont-show");
        $(dom).find(".my-custom-prod-desc-item-svg").removeClass("custom-prod-desc-item-svg-up");
    } else {
        $(dom).addClass("custom-prod-desc-item-title-active");
        $(dom).parent().find(".my-custom-prod-desc-item-cont").addClass("custom-prod-desc-item-cont-show");
        $(dom).find(".my-custom-prod-desc-item-svg").addClass("custom-prod-desc-item-svg-up");
    }
}
// 2025年2月18日16:38:44 为了改gift的图标的位置
function myCustomForGiftFn() {
    $(window).on('load', function () {
        // 你的代码
        let giftDom = $('#sca-gift-icon');
        let discountWrapDom = $('#myProdDCConfigDirectWrapId');
        discountWrapDom.prepend(giftDom);
        $('#sca-gift-icon').find('img').css('display', 'block')
    });
}
myCustomForGiftFn();

function myCustomGetPresaleDataStrFn(variantId, type) {
    let myProdPresaleObj = $('#myProdPresaleObjSavedId').text();
    myProdPresaleObj = myProdPresaleObj ? JSON.parse(myProdPresaleObj) : {};
    console.log(myProdPresaleObj, 'myProdPresaleObjmyProdPresaleObj')
    let typeStrMap = {
        '1': ' より順次発送予定',
        '2': '',
    }
    let str = '';
    if (myProdPresaleObj && myProdPresaleObj[variantId]) {
        str = myProdPresaleObj[variantId] + typeStrMap[type];
    }
    return str;
}

// 2025年7月10日18:06:43 为了 功能模块的新增
function myCustomFuncConfigStartFn() {
    $('.my-custom-product-func-configwrap:not(.no-click-bind)').on('click', function (event) {
        let $dom = $(this);
        let parentDom = $dom.parent();
        let dialogDom = parentDom.find('.my-custom-product-func-dialogwrap');
        let data_save_url = $dom.attr('data-save-url')
        let data_type = $dom.attr('data-type')
        // console.log(data_save_url, 'data_save_url', data_type)
        if (data_type === 'link') {
            // 打开新的页面跳转
            window.open(data_save_url, '_blank');
        } else if (data_type === 'dialog_qa'){
            let dialogContWrapDom = dialogDom.find('.my-custom-product-func-dialogcontwrap');
            dialogContWrapDom.addClass('scrollY');
            dialogDom.show();
        } else {
            dialogDom.find('iframe').attr('src', data_save_url)
            dialogDom.find('img').attr('src', data_save_url)
            dialogDom.show();
        }
    })
    $('.my-custom-product-func-dialog-closebtn, .my-custom-product-func-dialog-closebtn-qa').on('click', function (event) {
        $(this).parent().parent().hide();
    })
}

/**
 * 2025年8月22日为了 维保服务和 意外险
*/

// let myCustomProdWBProdId = myCustomProdSaveObj.id;
// 获取或者写好 所有维保的 变体id 和变体内容
// 获取当前选中的变体ID，如果没有选中的变体，那么就默认选中第一个变体

// 找出 当前选中的变体的 对应的维保的 变体id和变体内容

// 如果有对应的，那么应该设置好 维保的 变体id和变体内容， 然后显示对应的内容

// 监听 check 的点击事件 & 整个的点击，并且改变状态，并且记录状态和当前的 维保的值


// myCustomCartUpcartObj.WBZVariantAndNum  myCustomCartUpcartObj.BXZVariantAndNum

window.myCustomProdWBSaveObj = {
    WBStatus: false, // 维保的状态
    // 维保的 变体id和变体内容
    // 当前产品页面选中的变体ID， 对应的维保的内容
    curWBObj: {
        id: '',
        price: '',
        link: '',
    },
    BXStatus: false, // 保险的状态
    curBXObj: {
        id: '',
        price: '',
        link: '',
    },
}

function myCustomWBInitFn(){
    // 获取数据，把数据进行转换
}

function myCustomWBAndBxDomLoadInitFn(){
    myCustomWBInitFn();

    $('#myCustomWBItemAddOne').on('click', function(event){
        // 阻止默认事件
        event.preventDefault();
        event.stopPropagation();
        // myCustomWBItemClickFn('myCustomWBItemAddOne', 'WBStatus');
        // myCustomAddonBXWBDialogShowFn('wb', true);
        if(myCustomProdWBSaveObj?.WBStatus) {
            myCustomWBItemClickFn('myCustomWBItemAddOne', 'WBStatus');
        } else {
            myCustomAddonBXWBDialogShowFn('wb', true);
        }
    })
    $('#myCustomWBItemAddOne').find('.my-custom-wb-item-addwrap-leftstatus').on('click', function(event){
        // 阻止默认事件
        event.preventDefault();
        event.stopPropagation();
        if(myCustomProdWBSaveObj?.WBStatus) {
            myCustomWBItemClickFn('myCustomWBItemAddOne', 'WBStatus');
        } else {
            myCustomAddonBXWBDialogShowFn('wb', true);
        }
    })

    $('#myCustomWBItemAddTwo').on('click', function(event){
        // 阻止默认事件
        event.preventDefault();
        event.stopPropagation();
        // myCustomWBItemClickFn('myCustomWBItemAddTwo', 'BXStatus');
        // myCustomAddonBXWBDialogShowFn('bx', true);
        if(myCustomProdWBSaveObj?.BXStatus) {
            myCustomWBItemClickFn('myCustomWBItemAddTwo', 'BXStatus');
        } else {
            myCustomAddonBXWBDialogShowFn('bx', true);
        }
    })
    $('#myCustomWBItemAddTwo').find('.my-custom-wb-item-addwrap-leftstatus').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        // myCustomWBItemClickFn('myCustomWBItemAddTwo', 'BXStatus');
        if(myCustomProdWBSaveObj?.BXStatus) {
            myCustomWBItemClickFn('myCustomWBItemAddTwo', 'BXStatus');
        } else {
            myCustomAddonBXWBDialogShowFn('bx', true);
        }
    })

    $('#myCustomWBItemAddOne').find('.my-custom-wb-item-addwrap-rightdetail').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        window.open($(this).attr('data-href'));
    })
    $('#myCustomWBItemAddTwo').find('.my-custom-wb-item-addwrap-rightdetail').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        window.open($(this).attr('data-href'));
    })

    // 如果当前产品id是维保或者保险的产品ID， 隐藏点击加购的按钮
    setTimeout(()=>{
        let productId = window.myCustomProdSaveObj?.id;
        if (productId) {
            // if (productId+'' === '8284333146287' || productId+'' === '7331989291183') {
            if (productId+'' === '8284333146287') {
                $('.shopify-payment-button').html('');
                $('.product-template-my-AddOn-form-right-btnwrap').html('');
                // 删除 维保的 按钮
                $('.product-template-my-AddOn-form-wrap').find('.product-template-my-AddOn-form-mb-right-btn').remove();
            }
        }
    })
    myCustomProdAddwrapWbdialogPolicycheckFn();
}

// 监听当前产品变体ID的变化，根据传入的主产品的变体ID，执行函数
function myCustomWBVariantIdChangeFn(variantId) {
    console.log(variantId, 'variantId');
    // 循环 对象，获取出值，看看这个值有没有包含
    if(!variantId) {
        variantId = myCustomProdSaveGBObj.curVariantId;
    }
    if (!variantId) return;
    console.log(variantId, 'variantIdvariantId');
    console.log(myCustomCartUpcartObj.WBZVariantAndNum, 'WBZVariantAndNumWBZVariantAndNum');

    if (!myCustomCartUpcartObj.WBZVariantAndNum?.length && !myCustomCartUpcartObj.BXZVariantAndNum?.length) return;

    let curWBObj = {};
    myCustomCartUpcartObj.WBZVariantAndNum.map((item) => {
        item.zVariantArr.map((item2) => {
            if(item2.variantId+'' === variantId+''){
                // 找到对应的 维保的 变体id和变体内容
                curWBObj = item;
                console.log(curWBObj, 'curWBObj');

                // 设置好 维保的 变体id和变体内容
                myCustomProdWBSaveObj.curWBObj = {...curWBObj};
                
            }
        })
    })

    if (curWBObj&&curWBObj.fVariantId){
        curWBObj?.price&&$('#myCustomWBItemAddOne').find('.myCustomProdWBPriceId').text(myCustomAddOnformatNumberWithCommas(curWBObj.price));
        $('#myCustomWBItemAddOne').find('.my-custom-wb-item-addwrap-rightdetail').attr('data-href', curWBObj.link);
        // $('#myCustomWBItemAddOne').addClass('active');
        // 显示 维保的 内容
        $('#myCustomWBItemAddOne').addClass('show');
        // 显示 维保的 标题
        $('#myCustomWBItemAddOne').parent().find('.my-custom-prod-wb-addwrap-title').addClass('show');
    } else {
        $('#myCustomWBItemAddOne').removeClass('active');
        $('#myCustomWBItemAddOne').find('.my-custom-wb-item-addwrap-leftstatus').removeClass('active');
        $('#myCustomWBItemAddOne').removeClass('show');
    }
    
    let curBXObj = {};
    myCustomCartUpcartObj.BXZVariantAndNum.map((item)=>{
        item.zVariantArr.map((item2) => {
            if (item2.variantId+'' === variantId+''){
                // 显示保险的内容，并显示块样式
                curBXObj = item;
                myCustomProdWBSaveObj.curBXObj = {...curBXObj};
                console.log(curBXObj, 'curBXObjcurBXObj');
            }
        })
    })
    if (curBXObj&&curBXObj.fVariantId){
        curBXObj.price&&$('#myCustomWBItemAddTwo').find('.myCustomProdWBPriceId').text(myCustomAddOnformatNumberWithCommas(curBXObj.price));
        $('#myCustomWBItemAddTwo').find('.my-custom-wb-item-addwrap-rightdetail').attr('data-href', curBXObj.link);
        // $('#myCustomWBItemAddTwo').addClass('active');

        // 显示 维保的 内容
        $('#myCustomWBItemAddTwo').addClass('show');
        // 显示 维保的 标题
        $('#myCustomWBItemAddOne').parent().find('.my-custom-prod-wb-addwrap-title').addClass('show');
    } else {
        $('#myCustomWBItemAddTwo').removeClass('active');
        $('#myCustomWBItemAddTwo').find('.my-custom-wb-item-addwrap-leftstatus').removeClass('active');
        $('#myCustomWBItemAddTwo').removeClass('show');
    }
}

window.addEventListener('DOMContentLoaded', ()=>{
    setTimeout(()=>{
        window.myCustomWBVariantIdChangeFn();
    },500)
})

function myCustomWBAndBxAfterFn(){
    myCustomProdWBSaveObj.WBStatus = false;
    myCustomProdWBSaveObj.BXStatus = false;
    $('#myCustomWBItemAddOne').removeClass('active');
    $('#myCustomWBItemAddOne').find('.my-custom-wb-item-addwrap-leftstatus').removeClass('active');
    $('#myCustomWBItemAddTwo').removeClass('active');
    $('#myCustomWBItemAddTwo').find('.my-custom-wb-item-addwrap-leftstatus').removeClass('active');
}

// 更改 维保服务  意外险的  选中的状态
function myCustomWBItemClickFn(eleIdStr, statusStr){
    console.log(eleIdStr, myCustomProdWBSaveObj[statusStr], 'myCustomProdWBSaveObj[statusStr]');
    if (myCustomProdWBSaveObj[statusStr]) {
        $('#' + eleIdStr).removeClass('active');
        $('#' + eleIdStr).find('.my-custom-wb-item-addwrap-leftstatus').removeClass('active');
        myCustomProdWBSaveObj[statusStr] = false;
    } else {
        $('#' + eleIdStr).addClass('active');
        $('#' + eleIdStr).find('.my-custom-wb-item-addwrap-leftstatus').addClass('active');
        myCustomProdWBSaveObj[statusStr] = true;
    }
    myCustomProductAddCartClassConstructor.addWBOrBXEventListenerFn();
}


/**
 * 弹窗 的 事件
*/
var myCustomWBBXDialogAddonObj = {
    isWBCheck: false,
    isBXCheck: false,
}
function myCustomAddonBXWBDialogShowFn(type, flag){
    // 是否展示 弹窗
    if (type==='wb'){
        if (flag) {
            $('#myCustomProdAddwrapWbdialog').addClass('show');
        } else {
            $('#myCustomProdAddwrapWbdialog').removeClass('show');
        }
    } else if (type=='bx'){
        if (flag) {
            $('#myCustomProdAddwrapBxdialog').addClass('show');
        } else {
            $('#myCustomProdAddwrapBxdialog').removeClass('show');
        }
    }
}

function myCustomProdAddwrapWbdialogPolicycheckFn(){
    // 点击了 弹窗的 取消按钮
    $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-closewrap').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        // 弹窗的 取消按钮 点击了
        myCustomAddonBXWBDialogShowFn('wb', false);
    })
    $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-closewrap').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        // 弹窗的 取消按钮 点击了
        myCustomAddonBXWBDialogShowFn('bx', false);
    })

    // 点击了 弹窗的 确定按钮
    $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-btnconfirmwrap').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        // 判断弹窗的隐协议是否勾选了。
        console.log(myCustomWBBXDialogAddonObj.isWBCheck, 'myCustomWBBXDialogAddonObj.isWBCheck');
        if (!myCustomWBBXDialogAddonObj.isWBCheck) {
            // 弹窗的 确定按钮 点击了，但是 没有勾选 弹窗的 复选框
            // 把报错的信息展示
            $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').addClass('show');
            return;
        } else {
            // 弹窗的 确定按钮 点击了，并且 勾选了 弹窗的 复选框
            // 把报错的信息隐藏
            $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').removeClass('show');
            myCustomAddonBXWBDialogShowFn('wb', false);
            myCustomWBItemClickFn('myCustomWBItemAddOne', 'WBStatus');
        }
    })
    $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-btnconfirmwrap').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        // 弹窗的 确定按钮 点击了
        // 判断弹窗的隐协议是否勾选了。
        console.log(myCustomWBBXDialogAddonObj.isBXCheck, 'myCustomWBBXDialogAddonObj.isBXCheck');
        if (!myCustomWBBXDialogAddonObj.isBXCheck) {
            // 弹窗的 确定按钮 点击了，但是 没有勾选 弹窗的 复选框
            // 把报错的信息展示
            $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').addClass('show');
            return;
        } else {
            // 弹窗的 确定按钮 点击了，并且 勾选了 弹窗的 复选框
            // 把报错的信息隐藏
            $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').removeClass('show');
            myCustomAddonBXWBDialogShowFn('bx', false);
            myCustomWBItemClickFn('myCustomWBItemAddTwo', 'BXStatus');
        }
    })

    $('#myCustomProdAddwrapWbdialog').find('input').on('change', function(event){
        console.log(this.checked, 'this.checked');
        myCustomWBBXDialogAddonObj.isWBCheck = this.checked || false;
        if (this.checked) {
            $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').removeClass('show');
        } else {
            $('#myCustomProdAddwrapWbdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').addClass('show');
        }
    })
    $('#myCustomProdAddwrapBxdialog').find('input').on('change', function(event){
        console.log(this.checked, 'this.checked');
        myCustomWBBXDialogAddonObj.isBXCheck = this.checked || false;
        if (this.checked) {
            $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').removeClass('show');
        } else {
            $('#myCustomProdAddwrapBxdialog').find('.my-custom-prod-addwrap-wbdialog-cont-policyerrwrap').addClass('show');
        }
    })
}

// -----start这是扫地机问卷功能的函数

// -----end这是扫地机问卷功能的函数

// -----start 2025年7月10日20:01:18 新增为了 产品的 插件的送礼物
const myCustomGiftGiveDialogShow = (flag) => {
    console.log(flag, 'myCustomGiftGiveDialogShowflag');
    if (flag) {
        $('.my-custom-product-gift-give-info-dialog').addClass('show');
    } else {
        $('.my-custom-product-gift-give-info-dialog').removeClass('show');
    }
}
// 监听变体变化，进行送礼物内容的展示或隐藏
function myCustomGiftVariantChangeFn(variantId) {
    // 如果没有传入 variantId，则取当前默认变体
    if (!variantId) {
        variantId = myCustomProdSaveGBObj.curVariantId;
    }
    if (!variantId || !window.myCustomProductGiftGiveList) return;
    // my-custom-product-gift-give-wrap
    let giftGiveWrapDom = $('.my-custom-product-gift-give-wrap');
    let hasGiftGive = false;
    window.myCustomProductGiftGiveList.map((item)=>{
        let fvariantItem = item.variants.find(j => j.id+'' === variantId+'');
        if (fvariantItem) {
            hasGiftGive = true;
        }
    })
    if (hasGiftGive) {
        giftGiveWrapDom&&giftGiveWrapDom.addClass('show');
    } else {
        giftGiveWrapDom&&giftGiveWrapDom.removeClass('show');
    }
}
// -----end 2025年7月10日20:01:18 新增为了 产品的 插件的送礼物

// -----start 2026年4月21日14:32:09 为了MSRP的计算
// 监听页面变体的变化，获取最后的变体价格和变体的折扣
function myCustomMsrpVariantChangeFn(variantId) {
    if (!variantId) {
        variantId = myCustomProdSaveGBObj.curVariantId;
    }
    console.log(variantId, 'myCustomMsrpVariantChangeFnvariantId');
    if (!variantId) return;
    // 获取当前变体的价格（JPY，单位为日元）
    let curVariantObj = myCustomProdSaveGBObj.curVariantObj;
    if (!curVariantObj || curVariantObj.id + '' !== variantId + '') {
        curVariantObj = (myCustomProdSaveObj.variants || []).find(v => v.id + '' === variantId + '') || {};
    }
    let price = curVariantObj.price;
    if (!price) return;
    console.log(price, 'pricepriceprice');

    let discount = 0;
    let type = 'none';
    let variantConfigObj = myCustomProdDCConfigObj.variantConfigObj;
    console.log(variantConfigObj, 'variantConfigObjvariantConfigObj');
    // direct 折扣
    if (variantConfigObj && variantConfigObj['direct'] && variantConfigObj['direct'].counponkey) {
        let number = variantConfigObj['direct'].number;
        if (number.indexOf('%') > -1) {
            type = 'percent';
            discount = parseFloat(number.replace(/[^0-9.-]+/g, '')) || 0;
        } else {
            type = 'direct';
            discount = parseFloat(number.replace(/[^0-9.-]+/g, '')) || 0;
        }
        console.log(discount, type, 'discountdiscountdiscount');
    }

    myCustomMsrpMoneyGetFn(price, discount, type);
}
function myCustomMsrpMoneyGetFn(price, discount, type) {
    // console.log(price, discount, type, 'myCustomMsrpMoneyGetFnprice, discount, type');
    // 不打折：price / 24；有折扣（如20%OFF）：price * (1 - discount/100) / 24
    // 结果向上取整后格式化展示到 myCustomProductMsrpMoneyId
    let msrpDom = document.getElementById('myCustomProductMsrpMoneyId');
    if (!msrpDom) return;

    let msrpMoney = 0;
    price = price / 100; // 转换为正常的价格
    // console.log(price, discount, type, 'myCustomMsrpMoneyGetFnpricepricepriceprice');
    if (type === 'direct') {
        msrpMoney = price - discount;
    } else if (type === 'percent') {
        msrpMoney = price * (1 - discount / 100);
    } else {
        msrpMoney = price;
    }
    msrpMoney = msrpMoney / 24;
    msrpMoney = Math.ceil(msrpMoney);
    // console.log(msrpMoney, 'msrpMoneymsrpMoneymsrpMoney');
    msrpDom.innerText = myCustomAddOnformatNumberWithCommas(msrpMoney);
}


// -----end 2026年4月21日14:32:09 为了MSRP的计算

// -----start 2026年5月14日17:44:28 为了评论插件的icon替换
function myCustomReviewPluginIconReplaceFn() {
    // jdgm-qa-badge__icon
    // 获取评论插件的 icon 的 dom，进行替换
    setTimeout(() => {
        let commentPluginIconDom = document.querySelector('.jdgm-qa-badge__icon');

        if (commentPluginIconDom) {
            commentPluginIconDom.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-left-text-fill" viewBox="0 0 16 16" style="color: #E0393A;">
            <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"/>
            </svg>`;
        }
    }, 1000)
}
// -----end 2026年5月14日17:44:28 为了评论插件的icon替换